export default "__VITE_ASSET__C7M_Dhz0__"